export class ResendActivationEmailRequest {
    constructor(
        public userId: string,
        public returnUrl: string,
        public propertyContactInviteToken: string | null) {
    }

}